<div class="tabs">
	<div class="selected" [style.left.%]="selectedLeft" [style.width.%]="selectedWidth"></div>

	<ng-content></ng-content>
</div>
